<template>
  <section class="bg-gray-50 py-16 md:py-24">
    <div class="max-w-7xl mx-auto bg-white rounded-2xl shadow-sm p-8 md:p-16">
      
      <div class="text-center">
        <p class="text-sm font-bold text-orange-500 uppercase tracking-wider">
          Confiança Comprovada
        </p>
        <h2 class="mt-2 text-3xl md:text-4xl lg:text-5xl text-gray-900">
          Empresas que <strong class="font-bold">Transformaram</strong> seus Resultados
        </h2>
        <p class="mt-4 max-w-2xl mx-auto text-base md:text-lg text-gray-600">
          Junte-se a centenas de empresas que já aumentaram seu faturamento com as soluções tecnológicas da OverX.
        </p>
      </div>

      <div class="mt-12">
        <div class="relative w-full overflow-hidden">
          <div class="flex animate-scroll">
            <template v-for="i in 2" :key="i">
              <div v-for="logo in logos" :key="logo.name" class="flex-shrink-0 mx-6">
                <img :src="logo.src" :alt="logo.name" class="h-8 object-contain filter grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-300" />
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div v-for="stat in stats" :key="stat.label" class="bg-orange-500 rounded-2xl p-8 text-center text-white">
          <p class="text-4xl lg:text-5xl font-bold">
            {{ stat.value }}
          </p>
          <p class="mt-2 text-base text-orange-100">
            {{ stat.label }}
          </p>
        </div>
      </div>

    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';

const stats = ref([
  { value: '97%', label: 'Clientes Satisfeitos' },
  { value: '127%', label: 'Aumento Médio em Vendas' },
  { value: '+1000', label: 'Pedidos na plataforma' }
]);
</script>

<style scoped>
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.animate-scroll {
  animation: scroll 20s linear infinite;
  display: flex; 
}
</style>